import {
  IdentityMelcoModelsGenericList1MelcoModelsReferralListItem,
  SelectField,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
//  import { useTranslation } from "react-i18next";

type DisplayRefferalDropDownProps = {
  callbackFn?: any;
  defaultRefferals: IdentityMelcoModelsGenericList1MelcoModelsReferralListItem;
};

export const DisplayRefferalDropDown: React.FC<
  DisplayRefferalDropDownProps
> = ({ callbackFn, defaultRefferals }) => {
  const { t } = useTranslation();

  return (
    <SelectField
      name="referral_code"
      label={t("licenses.basic.search.refferal.title")}
      options={(defaultRefferals.list ?? []).map((refferal) => {
        return {
          label: refferal.description!,

          value: refferal.code!,
        };
      })}
      showSearch
      optionFilterProp="label"
      onChange={(value: string, refferal) => {
        if (callbackFn) {
          callbackFn(value, refferal);
        }
      }}
    />
  );
};
